import { useSelector, useDispatch } from 'react-redux';
import { selectToken } from '../slices/authSlice';
import { groupApi } from '../api/groupApi';
import { wsUrl } from '../api/wsUrl';
import useReconnectingSocket from './useReconnectingSocket';

const REFETCH_ON_TYPES = new Set(['group-message', 'group-message-deleted']);

export default function useGroupMessagesSocket(groupId) {
  const token = useSelector(selectToken);
  const dispatch = useDispatch();
  const url = groupId && token ? `${wsUrl()}/ws?token=${token}&groupId=${groupId}` : null;

  useReconnectingSocket(url, (msg) => {
    if (REFETCH_ON_TYPES.has(msg.type)) {
      dispatch(groupApi.util.invalidateTags([{ type: 'GroupMessage', id: groupId }]));
    }
  });
}
